module.exports = __webpack_public_path__ + "static/sun-settings-af12cf5cd4aed2a241af2ed1f3d0371f.gif";